import { render, staticRenderFns } from "./LunBoBiao.vue?vue&type=template&id=2abd47e0&scoped=true&"
import script from "./LunBoBiao.vue?vue&type=script&lang=js&"
export * from "./LunBoBiao.vue?vue&type=script&lang=js&"
import style0 from "./LunBoBiao.vue?vue&type=style&index=0&id=2abd47e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abd47e0",
  null
  
)

export default component.exports